/** Shared HubSpot embed IDs — keep in sync with HubSpotForm / GatedResourceForm. */
export const HS_PORTAL_ID = '243089516';

/** "Schedule a personalized demo" — homepage BookDemoSection + sitewide default. */
export const HS_BOOK_DEMO_FORM_ID = '871c5a52-41b7-4c64-a4de-21fd4b5dba4b';
